import { useEffect, useRef } from 'react';
import Lenis from 'lenis';

let lenisInstance = null;

// Lets other code (route-change scroll reset, "back to top" buttons, etc.)
// route through Lenis instead of fighting it with a raw window.scrollTo.
export const getLenis = () => lenisInstance;

/**
 * Mounts one Lenis instance for the lifetime of the app and drives it with
 * requestAnimationFrame. Skipped entirely for prefers-reduced-motion.
 */
const useLenis = () => {
  const rafId = useRef(null);

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return undefined;

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.2,
    });
    lenisInstance = lenis;

    function raf(time) {
      lenis.raf(time);
      rafId.current = requestAnimationFrame(raf);
    }
    rafId.current = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId.current);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
};

export default useLenis;
